module.exports = __webpack_public_path__ + "img/1-3-IMG_3001.e87afe9f.png";